import React, { memo, forwardRef } from 'react';
import { createUseStyles } from '@Sage/hoi-poi-ui';

import ExcelIcon from '../../../icons/ExcelIcon';

import styles from './styles';
const useStyles = createUseStyles(styles, 'ExcelField');

const ExcelField = ({ displayName }, ref) => {
    const classes = useStyles();
    return (
        <span ref={ref} className={classes.headerIcon}>
            <div className={classes.icon}>
                <ExcelIcon />
            </div>
            {displayName}
        </span>
    );
};

export default memo(forwardRef(ExcelField));
